<template>
  <div>
    <!-- {{filterPayload}} -->
    <!-- <pre>{{studentAttendanceList}}</pre> -->
    <vs-card class="cstm_vx_card">
      <div slot="header">
        <h4 v-if="!$route.params.clientObject">All Teacher List</h4>
      </div>

      <div
        slot="header"
        class="flex items-center mb-4"
        v-if="$route && $route.params && $route.params.clientObject"
      >
        <vs-button
          type="border"
          @click="$router.push({ name: 'attendanceTeacher' }).catch(() => {})"
          icon="chevron_left"
        ></vs-button>

        <img
          style="width: 40px; height: 40px"
          class="rounded-full shadow-md block ml-2"
          v-if="$route.params.clientObject.picture"
          :src="$route.params.clientObject.picture"
          alt="image"
        />
        <img
          style="width: 40px; height: 40px"
          class="rounded-full shadow-md block ml-2"
          v-else
          src="http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png"
          alt="image"
        />
        <a style="font-weight: 600" class="ml-2">
          <!-- asdadasdasdad -->
          <span v-if="$route.params.clientObject.first_name"
            >{{ $route.params.clientObject.first_name }}
          </span>
          <span v-if="$route.params.clientObject.middle_name"
            >{{ $route.params.clientObject.middle_name }}
          </span>
          <span v-if="$route.params.clientObject.last_name">{{
            $route.params.clientObject.last_name
          }}</span>
        </a>
      </div>

      <ag-grid-vue 
        ref="agGridTable"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :style="{ minHeight: studentAttendanceList.length * 48 + 75 + 'px' }"
        :gridOptions="gridOptions"
        :animateRows="true"
        :floatingFilter="false"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :columnDefs="studentAttendanceListColumnDefs"
        :rowData="studentAttendanceList"
        @grid-ready="onGridReady"
      />
    </vs-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import TeacherAttendanceNameCell from '../table_components/TeacherAttendanceNameCell.vue'
import AttendanceCell from '../table_components/AttendanceCell.vue'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { attendanceMixin } from '../mixins/attendanceMixin'
import {
  fetchTeacherSingleAttendanceHistoryApi,
  setTeacherAttendanceApi
} from '@/api/attendance'

export default {
  mixins: [attendanceMixin, PermissionMiddleware],
  props: {
    filterPayload: {
      type: Object,
      required: true
    }
  },
  components: {
    AgGridVue,
    TeacherAttendanceNameCell,
    AttendanceCell
  },
  data () {
    return {
      studentAttendanceList: [],
      studentAttendanceListColumnDefs: [],
      gridOptions: {},
      gridApi: null
    }
  },
  created () {
    console.log(this.filterPayload)
    // this.fetchEnrolled(this.filterPayload)
    this.fetchSingle()
  },
  mounted () {
    if (!this.$route.params.clientObject) {
      this.studentAttendanceListColumnDefs.push(
        {
          headerName: 'Teacher Name',
          field: 'teacher_name',
          cellRendererFramework: Vue.extend(TeacherAttendanceNameCell)
        }
      )
    }

    this.studentAttendanceListColumnDefs.push(
      {
        headerName: 'Course Name',
        field: 'course_name'
      },
      {
        headerName: 'Date',
        field: 'schedule_date',
        valueFormatter: params => this.$options.filters.dateFormatLocalization(params.data.schedule_date)
      },
      {
        headerName: 'Time',
        field: 'time',
        valueFormatter: params => `${this.$options.filters.OnlytimeFormatLocalization(params.data.schedule_from_time[0])} - ${this.$options.filters.OnlytimeFormatLocalization(params.data.schedule_to_time[0])}`
      }
    )

    if (this.checkViewPermission()) {
      this.studentAttendanceListColumnDefs.push(
        {
          headerName: 'Attendance',
          field: 'attendance',
          minwidth: 200,
          maxWidth: 200,
          cellRendererFramework: Vue.extend(AttendanceCell),
          CellRendererParams: {
            leavingMouse: (data) => this.leavingMouse(data),
            //edit_permission: () => this.edit_permission(),
            markingAttendance: (a, b, c, d) => this.markingAttendance(a, b, c, d),
            editAttendance: (data) => this.editAttendance(data)
          }
        }
      )
    }
  },
  methods: {
    leavingMouse (attendanceInfo) {
      // console.log(attendanceInfo)
      if (
        typeof attendanceInfo.attendance === 'boolean' &&
        !attendanceInfo.attendance_marked
      ) {
        // console.log('hi')
        attendanceInfo.attendance_marked = true
      }
      console.log(attendanceInfo)
    },
    presenCheck () {
      console.log('hi')
    },
    editAttendance (attendanceInfo) {
      console.log(attendanceInfo)
      attendanceInfo.attendance_marked = false
      /* indextr.attendance = ''
      indextr.delayed_num = null
      indextr.delayed_input = true */
    },
    delayedFunc (index) {
      console.log('hi enter')
      index.delayed_input = false
    },
    async fetchSingle () {
      try {
        console.log('Hi')
        this.$vs.loading({ text: 'Fetching Attendance List' })
        const payload = {
          start_date: this.$moment(this.filterPayload.start_date).format(
            'YYYY-MM-DD'
          ),
          end_date: this.$moment(this.filterPayload.end_date).format(
            'YYYY-MM-DD'
          ),
          course_id: this.filterPayload.course_id,
          user_id: this.filterPayload.user_id || null,
          search: this.filterPayload.search || ''
        }
        const customer_id = localStorage.getItem('customer_id')
        const { data } = await fetchTeacherSingleAttendanceHistoryApi(
          customer_id,
          payload
        )
        console.log(data)
        this.mergeAttendace(data.data.users, data.data.attendance)

        // this.structuredStandardList(attendanceList)
        //
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    mergeAttendace (studentList, attendance) {
      const alreadyAttendanceGiven = attendance.map((ele) => {
        return {
          ...ele,
          attendance_id: ele.id,
          attendance_marked: true,
          schedule_date: [this.$moment(ele.attendance_date).format('YYYY-MM-DD')]
        }
      })

      let notGiven = []
      console.log(this.$route.params.clientObject)
      //checking for singleStudent And If Single Student Is there then need to do the client Side
      if (!this.$route.params.clientObject) {
        notGiven = studentList.map((ele) => {
          return {
            ...ele,
            attendance_id: null,
            attendance: null,
            delay_in_minutes: null,
            attendance_marked: false
          }
        })
      } else {
        console.log('Not Givent')
        notGiven = this.eachStudentNotMarkedData(studentList, attendance).map(
          (ele) => {
            return {
              ...ele,
              attendance_id: null,
              attendance: null,
              delay_in_minutes: null,
              attendance_marked: false
            }
          }
        )
      }
      // console.log(this.filterPayload.attendance_type)
      if (this.filterPayload.attendance_type === 'Marked') {
        this.studentAttendanceList = [...alreadyAttendanceGiven]
      } else if (this.filterPayload.attendance_type === 'UnMarked') {
        this.studentAttendanceList = [...notGiven]
      } else {
        this.studentAttendanceList = [...alreadyAttendanceGiven, ...notGiven]
      }
      console.log('SDSDSDSDSDSDSDSD')
      console.log(this.studentAttendanceList)
      const students = []
      for (let i = 0; i < this.studentAttendanceList.length; i++) {
        if (this.studentAttendanceList[i].schedule_date.length > 1) {
          for (
            let j = 0;
            j < this.studentAttendanceList[i].schedule_date.length;
            j++
          ) {
            students.push({
              ...this.studentAttendanceList[i],
              schedule_date: this.studentAttendanceList[i].schedule_date[j],
              schedule_from_time: [this.studentAttendanceList[i].schedule_from_time[j]],
              schedule_to_time: [this.studentAttendanceList[i].schedule_to_time[j]],
              schedule_id: [this.studentAttendanceList[i].schedule_id[j]]
            })
          }
        } else {
          students.push({
            ...this.studentAttendanceList[i],
            schedule_date: this.studentAttendanceList[i].schedule_date[0]
          })
        }
      }
      this.studentAttendanceList = students
      // this.studentAttendanceList = students
      /* this.studentAttendanceList = [...alreadyAttendanceGiven, ...notGiven]
      console.log(this.studentAttendanceList) */
    },
    eachStudentNotMarkedData (studentList, attendanceList) {
      console.log(studentList)
      const student = []
      const attendanceGivenCombination = attendanceList.map((ele) => {
        return `${ele.client_user_id}@${ele.course_id}@${ele.schedule_id}`
      })

      console.log(attendanceGivenCombination)
      console.log(this.filterPayload)
      for (let i = 0; i < studentList.length; i++) {
        const ele = studentList[i]
        for (let j = 0; j < ele.schedule_date.length; j++) {
          const eachScheduleDate = ele.schedule_date[j]
          const stringChecking = `${ele.client_user_id}@${ele.course_id}@${ele.schedule_id[j]}`
          console.log('string Checking', stringChecking)
          const format1 = 'YYYY-MM-DD HH:mm:ss'
          const format2 = 'YYYY-MM-DD'

          const eachScheduleDate1 = new Date(
            `${eachScheduleDate  } ${  ele.schedule_to_time[j]}`
          )
          const start_date1 = new Date(
            `${this.filterPayload.start_date  } 00:00:00`
          )
          const end_date1 = new Date(`${this.filterPayload.end_date  } 23:59:59`)
          // alert(end_date1)
          console.log(eachScheduleDate1)
          console.log(start_date1)
          console.log(end_date1)
          console.log('DSDSDSD+++++++++++++++++')
          // if (
          //   this.$moment(this.$moment(eachScheduleDate1)).isBetween(
          //     this.$moment(start_date1),
          //     this.$moment(end_date1)
          //   )
          // ) {
          //   if (!attendanceGivenCombination.includes(stringChecking)) {
          //     student.push({
          //       ...ele,
          //       schedule_date: [eachScheduleDate],
          //       schedule_from_time: [ele.schedule_from_time[j]],
          //       schedule_id: [ele.schedule_id[j]],
          //       schedule_to_time: [ele.schedule_to_time[j]]
          //     })
          //   }
          // }
          if (!attendanceGivenCombination.includes(stringChecking)) {
            student.push({
              ...ele,
              schedule_date: [eachScheduleDate],
              schedule_from_time: [ele.schedule_from_time[j]],
              schedule_id: [ele.schedule_id[j]],
              schedule_to_time: [ele.schedule_to_time[j]]
            })
          }
        }
      }
      // console.log(';nilesh')
      // studentList.forEach(ele => {
      //   ele.schedule_date.forEach(eachScheduleDate => {
      //     console.log(eachScheduleDate)

      //     const stringChecking = `${ele.client_user_id}@${ele.course_id}@${this.$moment(eachScheduleDate).format('YYYY-MM-DD')}`

      //     console.log(this.$moment(eachScheduleDate).isBetween(this.filterPayload.start_date, this.filterPayload.end_date))
      //     if (
      //       this.$moment(this.$moment(eachScheduleDate).format('YYYY-MM-DD')).isBetween(
      //         this.$moment(this.filterPayload.start_date).format('YYYY-MM-DD'),
      //         this.$moment(this.filterPayload.end_date).format('YYYY-MM-DD')
      //         )
      //       ) {
      //       if (!attendanceGivenCombination.includes(stringChecking)) {
      //         student.push({...ele, schedule_date:eachScheduleDate})

      //       }

      //     }
      //   })

      //   // true
      // })

      console.log(student)
      // console.log("SDSD+++++++++++++++++++++++++++++++++++++++++++")

      return student
    },
    async structuredStandardList (studentList) {
      return studentList.map((ele) => {
        return {
          attendance_id: null,
          id: ele.user_id,
          attendance: true,
          delay_in_minutes: 0,
          name: `${ele.first_name} ${ele.last_name}`,
          picture: `${ele.picture}`
        }
      })
    },
    markingAttendance (attendance, attendanceObject, type, event) {
      console.log('SDSD KUKKOOOO')
      console.log(attendanceObject)
      console.log(event)
      const payload = {
        course_id: attendanceObject.course_id,
        attendance_date: this.$route.params.clientObject
          ? attendanceObject.schedule_date
          : this.filterPayload.start_date,
        user_id: attendanceObject.user_id,
        attendance: attendanceObject.attendance,
        delay_in_minutes: attendanceObject.delay_in_minutes,
        schedule_id: attendanceObject.schedule_id[0]
      }
      console.log(attendance)
      console.log(payload)

      if (type === 'delayed') {
        if (
          attendanceObject.delay_in_minutes > 1 &&
          attendanceObject.delay_in_minutes <= 120
        ) {
          if (
            event &&
            'keyCode' in event &&
            event.keyCode === 13 &&
            type === 'delayed'
          ) {
            attendanceObject.attendance_marked = true
          }
          this.submitAttendance(payload)
        } else {
          this.showSuccessMessage(
            'Error',
            'Attendance must be between 1 And 120',
            'danger'
          )
        }
      } else {
        this.submitAttendance(payload)
      }
    },
    async submitAttendance (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const data = await setTeacherAttendanceApi(customer_id, payload)
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    }
  },
  directives: {},
  watch: {
    filterPayload: {
      deep: true,
      handler () {
        console.log(this.filterPayload)
        // this.fetchSingle()
        console.log(this.filterPayload)
        this.fetchSingle()
      }
    }
    /* 'studentAttendanceList' :  {
      deep:true,
      handler (value) {
        console.log(value) 
      }
      
    } */
  }
}
</script>

<style lang="scss" scoped>
</style>